import { graphql } from 'react-apollo';

import { getClientEnvironmentDetails } from '@sm/utils';

import { errorHandler as clientErrorHandler } from '../../../helpers/errorHandler';
import SaveTreatmentMutation from './SaveTreatment.graphql';

/**
 * If the user is LO and we have values from the Svc,
 * we can set a cookie for experimentsvc to injest
 * @param {Object} cookie
 * @return {null}
 */
const createCookie = cookie => {
  const { isBrowser } = getClientEnvironmentDetails();
  // no need to create a cookie if there isn't a cookie to create
  if (cookie.success === false || !cookie.name) return null;
  const { name, maxAge, assignments } = cookie;
  if (isBrowser) {
    const { host } = window.location;
    const domain = host.replace(/^[^.]+\./g, '');
    document.cookie = `${name}=${assignments}; max-age=${maxAge}; path=/; domain=${domain}`;
  }
  return null;
};

/**
 * Component to display a treatment
 * @param {String} when
 * @param {Object} treatments
 * @param {Boolean} control
 * @param {Function|Object} children
 * @returns {*}
 */
const Treatment = ({
  when,
  control,
  children,
  treatments,
  mutate = () => null,
}) => {
  const childElement = typeof children === 'function' ? children() : children;
  const allTreatments = Object.keys(treatments);

  // If experiments fails, or the user hasn't been assigned and experiment show the control.
  if (allTreatments.length === 0 && control) {
    return childElement;
  }

  // if our treatment exists in the object
  if (allTreatments.length) {
    if (treatments[when] && treatments[when].treatmentName) {
      // send the data back to experiments that we are showing this treatment
      const {
        treatmentId,
        experimentId,
        treatmentName,
        experimentName,
        assignmentType,
      } = treatments[when];
      mutate({
        variables: {
          input: {
            treatmentId,
            treatmentName,
            experimentId,
            experimentName,
            assignmentType,
          },
        },
      })
        .then(({ data }) => {
          if (data && data.saveExperimentTreatment)
            createCookie(data.saveExperimentTreatment);
        })
        .catch(e =>
          clientErrorHandler.logError(e, 'Unable to save experiment treatment')
        );
      // Let's return the child element without waiting for the mutation as the
      // mutation doesn't really impact the children.
      return childElement;
    }
  }
  return null;
};

export default graphql(SaveTreatmentMutation)(Treatment);
